import styled from '@emotion/styled';
import { Box } from '@qga/roo-ui/components';

const PackageOptionContent = styled(Box)``;

export default PackageOptionContent;
